
import { EnumGaranzieActions } from './garanzie_actions';
//import update from 'react-addons-update';
import update from 'immutability-helper';

const EnumActions = EnumGaranzieActions;

const initialState = {

    listGaranzie: [],
    detailsGaranzia: {
        id: null,
        nome: null,
        sigla: null,
        codBisogno: null,
        codRamo: null,
        insertDate: null,
        insertUser: null,
        updateDate: null,
        updateUser: null,
        deleteDate: null,
        deleteUser: null,
        note: null,
    },
    regimeFiscale: {

    },
    valoriAliquote: [],


}



const garanzie = (state, action) => {
    if (typeof state === 'undefined') {
        return initialState
    }

    let moduleName = "[GaranzieReducer.js]"
    switch (action.type) {

        case EnumGaranzieActions.GARANZIE_INITIALIZED:
            return initialState
        case EnumGaranzieActions.GARANZIE_LIST:
            return Object.assign({}, state, { listGaranzie: action.dati })

        case EnumGaranzieActions.GARANZIA_DETAILS:
            return Object.assign({}, state, { detailsGaranzia: action.dati })

        case EnumGaranzieActions.RF_DETAILS:
            return Object.assign({}, state, { regimeFiscale: action.dati })
        case EnumGaranzieActions.GARANZIE_HANDLE_CHANGE:
            return update(state, {
                detailsGaranzia: { $merge: action.dato }
            });
        case EnumGaranzieActions.RF_HANDLE_CHANGE:
            return update(state, {
                regimeFiscale: { $merge: action.dato }
            });
        case EnumGaranzieActions.GARANZIE_UPDATE:
            return update(state, action.garanzie
            );
        default:
            return state;
    }
}

export default garanzie;